export const modalContent = {
  background: "background",
  border: "solid 1px",
  borderTop: "none",
  borderBottomWidth: "0",
  borderColor: "grey9",

  "&:last-of-type": {
    borderBottomWidth: "1px",
    borderRadius: "0 0 8px 8px",
  },
};

export const image = {
  pt: "30px",
};

export const fixExpertDealerLocationButton = {
  boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.125)",
  padding: "27px 50px",
  fontSize: "30px",
};

export const actions = {
  px: "40px",
  py: "30px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",

  "> *": {
    my: "10px !important",
  },
};

export const details = {
  px: "40px",
  paddingBottom: "20px",
  fontFamily: "roboto",
  fontWeight: "light",
  fontSize: "14px",
  lineHeight: "1.29",
  letterSpacing: "0.05em",
};

export const item = {
  borderTop: "solid 1px",
  borderColor: "grey9",
  py: "20px",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
};

export const shareButtonsContainer = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  mx: "-5px",
  mb: "20px",

  "> button": {
    mx: "5px",
  },
};

export const iconButton = {
  border: "solid 1px",
  borderColor: "grey5",
};

export const value = {
  mt: "10px",
};

export const valueImage = ({ image }) => ({
  backgroundImage: `url(${image})`,
  backgroundPosition: "50% 50%",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  border: "1px solid",
  borderColor: "black",
  borderRadius: "8px",
  width: "98px",
  height: "63px",
});
